/* unplugin-vue-components disabled */// extracted by extract-css-chunks-webpack-plugin
module.exports = {"Instruction":"Instruction_eo-nO","text":"text_4KXM9","icon":"icon_If-pZ"};